import moment from 'moment'
import { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

import CurrentBankingAmount from './CurrentBankingAmount'

const BankingChart = ({ bankingHistoryData }) => {
  const [fakeHistoryData, setFakeHistoryData] = useState([])

  useEffect(() => {
    setFakeHistoryData(generateData(bankingHistoryData.balanceCents))
  }, [bankingHistoryData])

  function generateData(balanceCents) {
    const currentDate = new Date()
    const newData = []

    for (let i = 6; i > 0; i--) {
      const monthAgo = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1
      )
      const fluctuation = Math.random() * 0.1 - 0.2 // Fluctuate balance by +/-20%
      const newBalance = Math.round(balanceCents * (1 + fluctuation))

      const dataObject = {
        balanceCents: newBalance,
        createdAt: monthAgo,
        updatedAt: currentDate,
      }

      newData.push(dataObject)
    }

    // Add the current month's data
    newData.push({
      balanceCents: balanceCents,
      createdAt: currentDate,
      updatedAt: currentDate,
    })

    return newData
  }

  const dataForGraph = {
    labels: fakeHistoryData
      ? fakeHistoryData.map((balance) =>
          moment(balance.createdAt).format('MM/YYYY')
        )
      : [],
    datasets: [
      {
        label: 'Historique des 6 derniers mois des comptes de la copropriété',
        data: fakeHistoryData
          ? fakeHistoryData.map((balance) => balance.balanceCents / 100)
          : [],
        fill: false,
        backgroundColor: bankingHistoryData
          ? fakeHistoryData.map((balance, index, arr) =>
              index === arr.length - 1 ? '#c98b00' : '#143A5F'
            )
          : [],
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: 'category',
        ticks: {
          font: {
            size: 16,
            weight: 'bold',
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 16,
            weight: 'bold',
          },
          callback: function (value, index, values) {
            return value + '€'
          },
        },
      },
    },
    plugins: {
      datalabels: {
        color: 'white',
        font: {
          weight: 'bold',
          size: 16,
        },
        formatter: (value, ctx) => {
          const dataIndex = ctx.dataIndex
          const dataLength = ctx.chart.data.labels.length

          if (dataIndex === dataLength - 1) {
            return value
          } else {
            return ''
          }
        },
      },
    },
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ margin: '0px', paddingTop: '15px' }}
    >
      <Grid item xs={12}>
        <CurrentBankingAmount bankingHistoryData={bankingHistoryData} />
      </Grid>

      <Grid container style={{ height: '500px', position: 'relative' }}>
        <Bar data={dataForGraph} options={options} />
        <Grid
          container
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.75)',
            zIndex: 2,
          }}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <h2 style={{ textAlign: 'center' }}>Prochainement</h2>
            <p style={{ textAlign: 'center', fontSize: '16px' }}>
              Historique bancaire des 6 derniers mois bientôt disponible.
            </p>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default BankingChart
